<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-foreword element-with-heading" id="foreword">
<div class="heading heading-with-title heading-without-image" id="foreword-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Foreword</h1>
</div>
</div>
</div>
</div>
<div class="text" id="foreword-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center"><i>The Goddess Destiny</i></p>
</div>
</div>
<hr class="implicit-break"/>
<p class="first first-in-chapter first-full-width"><i><b>Destiny</b> is a strong character who is deeply humane, as well as acutely sensitive and extraordinarily intuitive. She is capable of great inspiration and creativity.</i></p>
<p class="subsq"><i>As a little girl, <b>Destiny</b> is adorable and very endearing, eager to please. It only takes an upheaval or dissension to knock her off kilter, and become lost in her inner world of daydreams.</i></p>
<p class="subsq"><i><b>Destiny</b> cultivates her ideology. Her remarkable inner strength allows her to take an interest in the social sciences, spirituality and the occult.</i></p>
<p class="subsq"><i>When it comes to love, <b>Destiny </b>has a sentimental and romantic soul who tends to idealise her sweetheart by putting him on a pedestal, with the risk of disappointment that this entails. She is quite feminine, and motherhood is likely to bring her great fulfilment.</i></p>
<p class="subsq"><i><b>Destiny</b> can achieve tremendous success. She could choose a career as a teacher, psychologist, sociologist, counsellor, social worker, children´s nurse, midwife or devoted secretary..., artist, musician..., astrologist, or medium... religion or an occupation of a philanthropic or voluntary nature, or even a career in politics.</i></p>
<p class="subsq"><i>Of course, <b>Destiny</b> could simply decide to dedicate herself to her family and would make a loving and attentive mother</i>.</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width"><i>This book is for Goddesses’ everywhere. It takes us back to France to find out what Destiny had in store for our very own superwomen, Rosie and Ruby, Anna, Tilly and Grace.</i></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// foreword.vue?b0df1b5e